/* unplugin-vue-components disabled */const { ref, computed, watchEffect } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-98df1122"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "pose-panel-wrap" };
const _hoisted_2 = { class: "axis-panel-wrap" };
const _hoisted_3 = { style: { "display": "flex", "justify-content": "space-between", "align-items": "center" } };
const _hoisted_4 = {
    class: "slider-bar-wrap",
    style: { "margin-top": "5px" }
};
const _hoisted_5 = _withScopeId(() => (0, vue_2.createElementVNode)("div", { class: "dashed-line" }, null, -1));
const _hoisted_6 = { class: "end-adjustment-wrap" };
const _hoisted_7 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { style: { "display": "block", "line-height": "24px" } }, "末端调整", -1));
const _hoisted_8 = { style: { "display": "flex", "gap": "2px", "align-items": "center", "margin-top": "5px" } };
const _hoisted_9 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { style: { "flex-shrink": "0" } }, "当前TCP", -1));
const _hoisted_10 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { style: { "flex-shrink": "0" } }, "参考坐标系", -1));
const _hoisted_11 = { style: { "display": "flex", "align-items": "center", "gap": "5px", "width": "100%" } };
const _hoisted_12 = { style: { "width": "calc(100% - 15px)" } };
const _hoisted_13 = { class: "position" };
const _hoisted_14 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { class: "input-label" }, "X", -1));
const _hoisted_15 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { class: "input-label" }, "Y", -1));
const _hoisted_16 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { class: "input-label" }, "Z", -1));
const _hoisted_17 = { class: "position" };
const _hoisted_18 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { class: "input-label" }, "Rx", -1));
const _hoisted_19 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { class: "input-label" }, "Ry", -1));
const _hoisted_20 = _withScopeId(() => (0, vue_2.createElementVNode)("span", { class: "input-label" }, "Rz", -1));
const model_1 = require("@/model");
const SliderItem_vue_1 = tslib_1.__importDefault(require("./SliderItem.vue"));
const work_1 = require("@/store/modules/work");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PosePanel',
    props: {
        robot: {
            type: model_1.Robot,
            require: true
        },
        title: {
            type: String,
            default: ''
        }
    },
    setup(__props) {
        const props = __props;
        const store = (0, work_1.useWork)();
        const curTcpId = ref('');
        const tcpOptions = computed(() => { var _a; return (_a = props.robot) === null || _a === void 0 ? void 0 : _a.tcps; });
        const curTcp = computed(() => props.robot.tcps.find(e => e.id === curTcpId.value));
        const coordinateSystem = computed(() => {
            return curTcp.value.getUcs().map(e => {
                return { label: e.name, value: e.id };
            });
        });
        watchEffect(() => {
            var _a;
            if (props.robot) {
                curTcpId.value = (_a = props.robot) === null || _a === void 0 ? void 0 : _a.tcp0.id;
            }
        });
        const reference = computed({
            get() {
                var _a, _b, _c, _d, _e;
                if (((_b = (_a = curTcp.value) === null || _a === void 0 ? void 0 : _a.reference) === null || _b === void 0 ? void 0 : _b.frame) != 'ucs') {
                    return ((_d = (_c = curTcp.value) === null || _c === void 0 ? void 0 : _c.reference) === null || _d === void 0 ? void 0 : _d.frame) || coordinateSystem.value[0].value || 0;
                }
                else {
                    return (_e = curTcp.value) === null || _e === void 0 ? void 0 : _e.originMachine.id;
                }
            },
            set(val) {
                var _a, _b, _c, _d, _e;
                if (((_a = curTcp.value) === null || _a === void 0 ? void 0 : _a.type) === model_1.ENTITY_TYPE.UCS || ((_b = curTcp.value) === null || _b === void 0 ? void 0 : _b.type) === model_1.ENTITY_TYPE.TCP) {
                    if (['global', 'base', 'tool'].includes(val)) {
                        (_c = curTcp.value) === null || _c === void 0 ? void 0 : _c.setReference(val);
                    }
                    else {
                        let origin = model_1.Project.current().findTargetById(val);
                        if (origin) {
                            (_d = curTcp.value) === null || _d === void 0 ? void 0 : _d.setReference('ucs', val);
                        }
                        else {
                            console.error('origin is null');
                        }
                    }
                }
                return (_e = curTcp.value) === null || _e === void 0 ? void 0 : _e.reference.frame;
            }
        });
        const deviceMaxCfg = computed(() => {
            if (props.robot && props.robot.model && props.robot.model.maxLimit) {
                return props.robot.model.maxLimit;
            }
            else {
                return [];
            }
        });
        const deviceMinCfg = computed(() => {
            if (props.robot && props.robot.model && props.robot.model.minLimit) {
                return props.robot.model.minLimit;
            }
            else {
                return [];
            }
        });
        function onSliderChangeCallback(item, val) {
            item.val = val;
        }
        function handleBackZero() {
            props.robot.axisAngles.forEach((axis, index) => {
                axis.val = props.robot.model.zero_angle[index];
            });
        }
        return (_ctx, _cache) => {
            var _a, _b;
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_option = (0, vue_2.resolveComponent)("el-option");
            const _component_el_select = (0, vue_2.resolveComponent)("el-select");
            const _component_el_checkbox = (0, vue_2.resolveComponent)("el-checkbox");
            const _component_el_input_number = (0, vue_2.resolveComponent)("el-input-number");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(__props.title), 1),
                        (0, vue_2.createVNode)(_component_el_button, {
                            onClick: handleBackZero,
                            size: "small"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)("回零")
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((_a = __props.robot) === null || _a === void 0 ? void 0 : _a.axisAngles, (item, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: `axis${index}`
                            }, [
                                (0, vue_2.createVNode)(SliderItem_vue_1.default, {
                                    onSliderChange: onSliderChangeCallback,
                                    item: item,
                                    "onUpdate:item": (value) => onSliderChangeCallback(item, value),
                                    minLimit: -(0, vue_2.unref)(deviceMinCfg)[index] || 0,
                                    maxLimit: (0, vue_2.unref)(deviceMaxCfg)[index] || 360,
                                    name: `A${index + 1}`,
                                    isShowLocked: true
                                }, null, 8, ["item", "onUpdate:item", "minLimit", "maxLimit", "name"])
                            ]));
                        }), 128))
                    ]),
                    _hoisted_5
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                    _hoisted_7,
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        _hoisted_9,
                        (0, vue_2.createVNode)(_component_el_select, {
                            class: "ucs-select",
                            modelValue: (0, vue_2.unref)(curTcpId),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(curTcpId) ? (curTcpId).value = $event : null)),
                            size: "small"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(tcpOptions), (tcp) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_option, {
                                        key: tcp.id,
                                        label: tcp.name,
                                        value: tcp.id
                                    }, null, 8, ["label", "value"]));
                                }), 128))
                            ]),
                            _: 1
                        }, 8, ["modelValue"]),
                        _hoisted_10,
                        (0, vue_2.createVNode)(_component_el_select, {
                            style: { "margin-left": "5px", "flex": "1" },
                            modelValue: (0, vue_2.unref)(reference),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((0, vue_2.isRef)(reference) ? (reference).value = $event : null)),
                            disabled: (_b = (0, vue_2.unref)(curTcp)) === null || _b === void 0 ? void 0 : _b.isTcpOrigin,
                            size: "small"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(coordinateSystem), (item, index) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_option, {
                                        key: index,
                                        label: item.label,
                                        value: item.value
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item.label), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["label", "value"]));
                                }), 128))
                            ]),
                            _: 1
                        }, 8, ["modelValue", "disabled"])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                        (0, vue_2.createVNode)(_component_el_checkbox, {
                            style: { "width": "15px" },
                            modelValue: __props.robot.isLockedTcp,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((__props.robot.isLockedTcp) = $event))
                        }, null, 8, ["modelValue"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                _hoisted_14,
                                (0, vue_2.createVNode)(_component_el_input_number, {
                                    class: "input-number",
                                    modelValue: ((0, vue_2.unref)(curTcp) || {}).x,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((((0, vue_2.unref)(curTcp) || {}).x) = $event)),
                                    precision: 2,
                                    step: 0.1,
                                    placeholder: "inputX",
                                    "value-on-clear": 0,
                                    controls: false,
                                    disabled: true,
                                    size: "small"
                                }, null, 8, ["modelValue"]),
                                _hoisted_15,
                                (0, vue_2.createVNode)(_component_el_input_number, {
                                    class: "input-number",
                                    modelValue: ((0, vue_2.unref)(curTcp) || {}).y,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((((0, vue_2.unref)(curTcp) || {}).y) = $event)),
                                    precision: 2,
                                    step: 0.1,
                                    placeholder: "inputY",
                                    "value-on-clear": 0,
                                    controls: false,
                                    disabled: true,
                                    size: "small"
                                }, null, 8, ["modelValue"]),
                                _hoisted_16,
                                (0, vue_2.createVNode)(_component_el_input_number, {
                                    class: "input-number",
                                    modelValue: ((0, vue_2.unref)(curTcp) || {}).z,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((((0, vue_2.unref)(curTcp) || {}).z) = $event)),
                                    precision: 2,
                                    step: 0.1,
                                    placeholder: "inputZ",
                                    "value-on-clear": 0,
                                    controls: false,
                                    disabled: true,
                                    size: "small"
                                }, null, 8, ["modelValue"])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                _hoisted_18,
                                (0, vue_2.createVNode)(_component_el_input_number, {
                                    class: "input-number",
                                    modelValue: ((0, vue_2.unref)(curTcp) || {}).rx,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((((0, vue_2.unref)(curTcp) || {}).rx) = $event)),
                                    precision: 4,
                                    step: 0.1,
                                    placeholder: "inputX",
                                    "value-on-clear": 0,
                                    controls: false,
                                    disabled: true,
                                    size: "small"
                                }, null, 8, ["modelValue"]),
                                _hoisted_19,
                                (0, vue_2.createVNode)(_component_el_input_number, {
                                    class: "input-number",
                                    modelValue: ((0, vue_2.unref)(curTcp) || {}).ry,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((((0, vue_2.unref)(curTcp) || {}).ry) = $event)),
                                    precision: 4,
                                    step: 0.1,
                                    placeholder: "inputY",
                                    "value-on-clear": 0,
                                    controls: false,
                                    disabled: true,
                                    size: "small"
                                }, null, 8, ["modelValue"]),
                                _hoisted_20,
                                (0, vue_2.createVNode)(_component_el_input_number, {
                                    class: "input-number",
                                    modelValue: ((0, vue_2.unref)(curTcp) || {}).rz,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((((0, vue_2.unref)(curTcp) || {}).rz) = $event)),
                                    precision: 4,
                                    step: 0.1,
                                    placeholder: "inputZ",
                                    "value-on-clear": 0,
                                    controls: false,
                                    disabled: true,
                                    size: "small"
                                }, null, 8, ["modelValue"])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
